<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      :model="formState"
      ref="formRef"
      :rules="rules"
      :labelCol="{
        span: 4,
      }"
    >
      <a-form-item label="项目名称" name="project">
        <a-input
          v-model:value="formState.project"
          placeholder="请输入项目名称"
        ></a-input>
      </a-form-item>
      <a-form-item label="项目简称" name="projectAS">
        <a-input
          v-model:value="formState.projectAS"
          placeholder="请输入项目简称"
        ></a-input>
      </a-form-item>
      <a-form-item label="负责人" name="username">
        <staff
          v-if="modalConfig.visible"
          ref="staffRef"
          :echoStaff="formState.userId"
          :echostaffUserName="formState.username"
        ></staff>

        <!-- <a-input
          v-model:value="formState.username"
          placeholder="请输入项目负责人"
        ></a-input> -->
      </a-form-item>

      <a-form-item label="项目阶段" name="projectLifeCycle">
        <a-select
          v-model:value="formState.projectLifeCycle"
          :options="projectLifeCycleOptions"
          placeholder="请选择项目阶段"
        >
        </a-select>
      </a-form-item>

      <a-form-item label="项目状态" name="projectStatus">
        <a-select
          v-model:value="formState.projectStatus"
          placeholder="请选择项目状态"
        >
          <a-select-option value="未开始">未开始</a-select-option>
          <a-select-option value="进行时">进行时</a-select-option>
          <a-select-option value="结束">结束</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { saveProjectLifeCycle } from "@/request/view/project";
import { debounce, Toast } from "@/utils";
import { projectLifeCycleOptions } from "@/views/rdmanagement/components/database/options";
import staff from "@/components/chooseStaff/staff.vue";

export default defineComponent({
  components: { staff },
  setup(props, context) {
    const staffRef = ref();
    const store = useStore();

    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const formState = reactive({
      id: null,
      project: null,
      projectLifeCycle: null,
      projectStatus: null,
      userId: null,
      projectAS: null,
      username: null,
    });

    const rules = {
      project: [
        {
          required: true,
          message: "请输入项目名称",
          trigger: "blur",
          type: "any",
        },
      ],
      username: [
        {
          required: true,
          message: "请输入项目负责人",
          trigger: "blur",
          type: "any",
        },
      ],
      projectLifeCycle: [
        {
          required: true,
          message: "请选择项目生命周期阶段",
          trigger: "blur",
          type: "any",
        },
      ],
      projectStatus: [
        {
          required: true,
          message: "请输入项目简称",
          trigger: "blur",
          type: "any",
        },
      ],
      projectAS: [
        {
          required: true,
          message: "请选择项目状态",
          trigger: "blur",
          type: "any",
        },
      ],
    };

    const formRef = ref();

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      staffRef.value.clearSelect();
      formRef.value.clearValidate();
      modalConfig.title = null;
      modalConfig.type = null;
      modalConfig.visible = false;
    };

    /**
     * @params { 'update' | 'insert' } options.type
     * @params { string } options.title
     * @params { data } options.data
     */
    const showModal = (options) => {
      const { type, title, data } = options;

      modalConfig.type = type;
      modalConfig.title = title;
      modalConfig.visible = true;

      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const handleOk = debounce(() => {
      const { noticeStaffString, staffName, staffUserName } =
        staffRef.value.getChooseStaff();

      formState.userId = noticeStaffString;
      formState.username = staffUserName.toString();
      formRef.value
        .validate()
        .then(() => {
          saveProjectLifeCycle(formState).then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            context.emit("updateTable");
            resetForm();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }, 200);

    const handleCancel = () => {
      resetForm();
    };

    return {
      staffRef,
      modalConfig,
      handleOk,
      showModal,
      handleCancel,
      projectLifeCycleOptions,
      formState,
      formRef,
      rules,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
